import React from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
const StyledTraceBoardEmptyState = styled.div `
  display: flex;
  flex-direction: column;
  padding: 50px;
  margin: 56px 46px;
  align-self: center;
  background-color: white;
  align-content: center;
  justify-content: center;
  text-align: center;
  img {
    align-self: center;
    width: 240px;
    margin-top: 20px;
  }
  .title {
    margin-top: 50px;
  }
  ${props => props.theme.breakpoints.up('md')} {
    width: 65%;
  }
  ${props => props.theme.breakpoints.only('xs')} {
    padding: 50px 24px;
  }
`;
const TraceBoardEmptyState = props => {
    const { className } = props;
    return (React.createElement(StyledTraceBoardEmptyState, { className: className },
        React.createElement("img", { alt: 'Empty Trace Board', src: '/assets/empty-state-references.png' }),
        React.createElement(Typography, { variant: 'h6', className: 'title' }, "Looking a little empty?"),
        React.createElement(Typography, { variant: 'subtitle1' }, "Be the first to add content for traceability. Click the + icon in the column"),
        React.createElement(Typography, { variant: 'subtitle1' }, "above to get started")));
};
export default TraceBoardEmptyState;
//# sourceMappingURL=TraceBoardEmptyState.js.map